import React from 'react';
import * as _ from 'lodash';
import { GateService } from '../../../services/Gates';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import DropdownSelector from '../../dropdowns/DropdownSelector';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

/**
 * ゲートの複数選択 ドロップダウン
 * @param selectedValues {array} 初期値
 * @param onSelect {func} 選択処理時のcallback処理
 */
export const GatesDropdown = ({ selectedValues, onSelect, clearFlag }) => (
  <DropdownSelector
    className='form-element__element'
    label='未選択'
    multiple={true}
    selectorName='gate_id'
    api={params =>
      // 検索専用のグループ一覧
      GateService.list(SessionStorageService.getFieldId(), params)
    }
    apiParams={{
      limit: REQUEST_PARAMS.parentLimit,
      order: 'order_number_asc',
    }}
    sorted={data => {
      return _.orderBy(data, ['order_number', 'updated_at'], ['asc', 'desc']);
    }}
    apiSearchKey='name'
    selectedValues={selectedValues}
    keyName='name'
    valueName='id'
    apiBindDataKey={'gates'}
    onSelect={onSelect}
    widthClass='dropdown__item--wide'
    clearFlag={clearFlag}
  />
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/multi/Gates.jsx